import { take } from 'rxjs';

import { responseHandler } from '../../../shared/responseHandler/responseHandler.ts';
import { CustomerCRMNotesRes, customerService } from '../services/customer.service.ts';
import { ITabState } from '../states/tabState.model.ts';

export const defaultCustomerCRMNotes: CustomerCRMNotesRes = [];

export async function resolveDataForCRMTab(data: ITabState): Promise<ITabState> {
  data.customerCRMNotes = data?.customerId
    ? await customerService.globHelpers.streamToPromise(
        customerService.sub.getCustomerCRMNotes().pipe(
          responseHandler<CustomerCRMNotesRes>({
            errorReturnType: defaultCustomerCRMNotes,
          }),
          take(1),
        ),
        () => {
          customerService.pub.getCustomerCRMNotes({ customerId: data.customerId! });
        },
      )
    : defaultCustomerCRMNotes;
  return data;
}
